"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const SvgLock = (props, ref) => (React.createElement("svg", { ...props, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 1024 1024", fill: "currentColor", className: `Icon ${props?.className || ""}`, ref: ref },
    React.createElement("path", { d: "M875.893 435.055c22.265 0 40.076 17.28 38.592 38.88V985.12c0 21.6-17.812 38.879-40.076 38.879H150.076C127.81 1024 110 1006.72 110 985.121V475.374c0-21.6 17.811-38.879 40.076-38.879h57.887c8.906 0 14.843-7.2 14.843-14.4V282.42c0-159.835 136.555-287.992 301.31-282.232 157.335 5.76 279.047 135.356 279.047 287.992v132.477c0 8.64 7.422 14.4 14.843 14.4zM313.348 282.42h-1.485v139.677c0 8.64 7.422 14.4 14.843 14.4h374.041c8.906 0 14.843-7.2 14.843-14.4V288.179c0-105.117-83.12-194.395-191.473-200.154-115.775-5.76-210.77 83.517-210.77 194.394" })));
const ForwardRef = (0, react_1.forwardRef)(SvgLock);
exports.default = ForwardRef;
